import { render, staticRenderFns } from "./PrivilegeList.vue?vue&type=template&id=56922762&scoped=true"
import script from "./PrivilegeList.vue?vue&type=script&lang=js"
export * from "./PrivilegeList.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeList.vue?vue&type=style&index=0&id=56922762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56922762",
  null
  
)

export default component.exports